import { yupResolver } from '@hookform/resolvers/yup';
import {
  ExchangeRateName,
  EXCHANGE_RATE_NAME_TO_CURRENCY,
  RegularCurrencies,
  SWAP_MIN_AMOUNTS,
} from '@okletsplay/core';
import { useForm, UseFormReturn } from 'react-hook-form';
import { DEFAULT_PAIR } from '../constants/swap-pairs';
import { buildSwapFormSchema } from './swap-form-schema';

export interface SwapFormFields {
  pair: ExchangeRateName;
  sell: number;
  buy: number;
  selectedSide: 'buyingCurrency' | 'sellingCurrency';
}

interface UseSwapFormHook {
  form: UseFormReturn<SwapFormFields>;
}

export const useSwapForm = (...args: Parameters<typeof buildSwapFormSchema>): UseSwapFormHook => {
  const formResolver = yupResolver(buildSwapFormSchema(...args));

  const form = useForm<SwapFormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: {
      pair: DEFAULT_PAIR,
      buy: 0,
      sell: SWAP_MIN_AMOUNTS[
        EXCHANGE_RATE_NAME_TO_CURRENCY[DEFAULT_PAIR].sell as RegularCurrencies
      ],
      selectedSide: 'sellingCurrency',
    },
  });

  return { form };
};
